import { createLocalStorageStateHook } from 'use-local-storage-state';

const useDetermineDarkModeAutomatically = createLocalStorageStateHook(
  'determine-dark-mode-automatically',
  true
);

export default useDetermineDarkModeAutomatically;
